import ready from '../utils/ready';

const resetForm = (form: Element) => {
  const container = form?.parentNode?.parentNode?.parentNode;
  if (!container) return;
  const formSuccess = container.querySelector('.wayke__form--success');
  const formParent = container.querySelector('.modal__body') as HTMLElement;
  const errors = formParent.querySelectorAll('.form__group--error');
  const alerts = formParent.querySelectorAll('.form__alert');

  formSuccess?.classList.add('hidden');
  formParent?.classList.remove('hidden');

  errors.forEach((error) => {
    error.classList.remove('form__group--error');
  });

  alerts.forEach((alert) => {
    alert.setAttribute('hidden', '');
  });

  if (window.grecaptcha) {
    window.grecaptcha.reset();
  }

  form.querySelectorAll('.form__group').forEach((formGroup: Element) => {
    const element = formGroup.querySelector('input, textarea') as HTMLInputElement;
    const fieldset = formGroup.querySelector('.form__fieldset');
    const radioGroup = fieldset?.querySelectorAll(
      '.input-selection__input[type="radio"]'
    ) as NodeListOf<HTMLInputElement>;
    const checkboxGroup = fieldset?.querySelectorAll(
      '.input-selection__input[type="checkbox"]'
    ) as NodeListOf<HTMLInputElement>;

    if (!element) return true;
    switch (element.type) {
      case 'textarea':
      case 'email':
      case 'text':
        const value = element.getAttribute('defaultvalue');
        element.value = value || '';
        break;
      case 'radio':
        if (radioGroup) {
          radioGroup.forEach((item, index) => {
            if (index === 0) {
              item.checked = true;
            }
          });
        }
        break;
      case 'checkbox':
        if (checkboxGroup) {
          checkboxGroup.forEach((item) => {
            if (item.checked) {
              item.checked = false;
            }
          });
        }
        break;
      default:
        break;
    }
  });
};

const validate = (x: Element, validationButton: { [key: string]: boolean | undefined }) => {
  let selectedValue;
  const reEmail =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const checkedInputs = x.querySelectorAll('input:checked') as NodeListOf<HTMLInputElement>;
  const inputElement = x.querySelector('input, textarea') as HTMLInputElement | null;
  const req = inputElement?.hasAttribute('required');

  if (!inputElement) return true;

  checkedInputs.forEach((isChecked) => {
    if (isChecked) {
      selectedValue = true;
    }
  });

  switch (inputElement.type) {
    case 'email':
      if (req) {
        return reEmail.test(String(inputElement.value).toLocaleLowerCase());
      }
      return (
        inputElement.value.length === 0 ||
        reEmail.test(String(inputElement.value).toLocaleLowerCase())
      );
    case 'textarea':
    case 'text':
      if (req) {
        return inputElement.value.length > 0;
      }
      return true;
    case 'radio':
      if (!validationButton[inputElement.name]) {
        if (selectedValue) {
          validationButton[inputElement.name] = true;
          return true;
        }
        return false;
      }
      return true;
    case 'checkbox':
      if (req && !validationButton[inputElement.name]) {
        if (selectedValue) {
          validationButton[inputElement.name] = true;
          return true;
        }
        return false;
      }
      return true;
    default:
      return true;
  }
};

const formHandler = () => {
  const formContainers = document.querySelectorAll('.container, .form-conversion-container');
  for (let i = 0; i < formContainers.length; i++) {
    const formContainer = formContainers[i];

    const formOpenModalButton = formContainer.querySelector('.wayke__form--open-modal-button');
    const formModal = formContainer.querySelector('.modal');
    const formParent = formContainer.querySelector('.modal__body');
    const form = formContainer.querySelector('form');
    const formSuccess = formContainer.querySelector('.wayke__form--success');
    const formError = formContainer.querySelector('.wayke-form-error');

    if (formOpenModalButton && formModal) {
      formOpenModalButton.addEventListener('click', () => {
        formModal.classList.add('modal--is-open');
      });
    }

    if (form) {
      const modal = formContainer.querySelector('.modal__action-btn');
      if (modal) {
        modal.addEventListener('click', () => resetForm(form));
      }

      const uiBlock = formContainer.querySelector('.modal__ui-block');
      if (uiBlock) {
        uiBlock.addEventListener('click', () => resetForm(form));
      }

      const requiredLabels = form.querySelectorAll('.form__label[required]');
      requiredLabels.forEach((requiredLabel) => {
        requiredLabel.classList.add('form__label--required');
      });

      form.addEventListener('submit', (e) => {
        e.preventDefault();
        formError?.classList.add('hidden');
        const validationButton: { [key: string]: boolean | undefined } = {};
        let hasError = false;

        form.querySelectorAll('.form__group').forEach((formGroup) => {
          const inputElement = formGroup.querySelector(
            'input, textarea'
          ) as HTMLInputElement | null;

          const emailElement = formGroup.querySelector(
            'input[type="email"]'
          ) as HTMLInputElement | null;

          if (!inputElement) return;

          const errorElement = formGroup;
          const errorMessage = formGroup.querySelector('.form__alert') as HTMLElement;
          let isValid = true;

          if (!validate(formGroup, validationButton)) {
            isValid = false;
          }

          if (!isValid && !validationButton[inputElement.name]) {
            errorMessage?.removeAttribute('hidden');
            errorElement?.classList.add('form__group--error');
            if (emailElement) {
              emailElement.setAttribute('haserror', '');
              if (emailElement.hasAttribute('haserror') && emailElement.value.length > 0) {
                errorMessage.innerHTML = 'E-postadress inte giltig.';
              }
            }
            hasError = true;
          } else if (isValid) {
            errorMessage?.setAttribute('hidden', '');
            errorElement?.classList.remove('form__group--error');
          }
        });

        const usesRecaptca = !!form.querySelector<HTMLDivElement>('.g-recaptcha');
        const recaptchaResponse = usesRecaptca
          ? form.querySelector<HTMLInputElement>('.g-recaptcha-response')?.value || ''
          : '';
        if (hasError || (usesRecaptca && !recaptchaResponse)) {
          formError?.classList.remove('hidden');
          return;
        }

        const q: string[] = [];
        form.querySelectorAll('input, textarea, select').forEach((entry) => {
          const el = entry as HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement;
          if (el.type === 'radio' || el.type === 'checkbox') {
            const radioOrCheckbox = el as HTMLInputElement;
            if (radioOrCheckbox.checked) {
              q.push(`${encodeURIComponent(el.name)}=${encodeURIComponent(el.value)}`);
            }
          } else {
            q.push(`${encodeURIComponent(el.name)}=${encodeURIComponent(el.value)}`);
          }
        });
        const body = q.join('&');
        fetch('/', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body,
        })
          .then((response) => {
            if (response.ok) {
              formSuccess?.classList.remove('hidden');
              formParent?.classList.add('hidden');
            } else {
              formError?.classList.remove('hidden');
            }
          })
          .catch(() => {
            formError?.classList.remove('hidden');
          });
      });
    }
  }
};

ready(formHandler);
